import React from "react";
import TappetLogo from "../../../assets/img/tappetbox.png";
import TapIcon from "../../../services/TapIcon";
import loginStyle from '../../auth/Login.module.css';

const TopHeader = ({
  passcode = "",
  mobile = "",
  sessionExpiry = "",
  phone = "9650-222-555",
  onLogout,
  showData = "true",
  title = "Passcode Portal",
  background = "#1B2559",
}) => {
  return (
    <>
      <nav
        style={{
          background: background,
          padding: "clamp(4px, 0.8vw, 8px) 0",
          color: "#fff",
        }}
      >
        <div className="container-fluid px-3 px-md-4">
          <div className="row align-items-center">
            <div className="col-6 col-md-7">
              <span
                style={{
                  fontSize: "clamp(12px, 1.2vw, 15px)",
                }}
              >
                <TapIcon.FontAwesomeIcon
                  icon={TapIcon.faShieldAlt}
                  style={{
                    marginRight: "8px",
                    color: "#3CB5A0",
                    fontSize: "clamp(14px, 1.2vw, 18px)",
                  }}
                />
                <span className="d-inline">{title}</span>
              </span>
            </div>
            <div className="col-6 col-md-5 text-end">
              <span
                style={{
                  fontSize: "clamp(11px, 1vw, 14px)",
                }}
              >
                Support: {phone}
              </span>
            </div>
          </div>
        </div>
      </nav>

      <div
        style={{
          background: "#fff",
          padding: "clamp(12px, 1.5vw, 18px) clamp(16px, 2vw, 28px)",
        }}
      >
        <div className="d-flex align-items-center justify-content-between ">
          <img
            src={TappetLogo}
            style={{
              height: "clamp(36px, 4vw, 48px)",
              width: "auto",
            }}
            alt="Tappet Logo"
          />
          {showData &&
            <button
              className="btn btn-light d-inline d-md-none"
              onClick={onLogout}
              style={{
                borderRadius: "clamp(10px, 1.2vw, 12px)",
                width: "clamp(70px, 7vw, 80px)",
                height: "clamp(36px, 4vw, 40px)",
                fontWeight: 600,
                fontSize: "clamp(12px, 1vw, 14px)",
                padding: "4px 8px",
                whiteSpace: "nowrap",
              }}
            >
              Logout
            </button>}


          {showData && (
            <div
              className="d-md-flex align-items-center flex-wrap d-none"
              style={{
                gap: "clamp(14px, 1.8vw, 28px)",
              }}
            >
              <Info
                icon={TapIcon.faIdBadge}
                title="Passcode"
                value={passcode}
              />

              <Info
                icon={TapIcon.faPhoneAlt}
                title="Mobile"
                value={mobile}
              />

              <Info
                icon={TapIcon.faClock}
                title="Session Expires In"
                value={sessionExpiry}
              />

              <button
                className="btn btn-light"
                onClick={onLogout}
                style={{
                  borderRadius: "clamp(10px, 1.2vw, 12px)",
                  width: "clamp(70px, 7vw, 80px)",
                  height: "clamp(36px, 4vw, 40px)",
                  fontWeight: 600,
                  fontSize: "clamp(12px, 1vw, 14px)",
                  padding: "4px 8px",
                  whiteSpace: "nowrap",
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const Info = ({ icon, title, value }) => (
  <div
    className="d-flex align-items-center"
    style={{
      gap: "clamp(8px, 1.2vw, 14px)",
    }}
  >
    <div
      style={{
        width: "clamp(36px, 4vw, 44px)",
        height: "clamp(36px, 4vw, 44px)",
        borderRadius: "50%",
        background: "#F8FAFC",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <TapIcon.FontAwesomeIcon
        icon={icon}
        style={{
          fontSize: "clamp(14px, 1.2vw, 18px)",
        }}
      />
    </div>

    <div>
      <div
        style={{
          fontSize: "clamp(10px, 0.8vw, 12px)",
          color: "#6B7A8F",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </div>

      <div
        style={{
          fontWeight: 700,
          fontSize: "clamp(12px, 1vw, 14px)",
          whiteSpace: "nowrap",
        }}
      >
        {value || "-"}
      </div>
    </div>
  </div>
);

export default TopHeader;